import { IRequestService } from "../../service/request/RequestService";
import { ICredentialsService } from "../../service/authentication/CredentialsService";

export default class GetRequestsInteractor {
  private requestService: IRequestService;
  private credentialsService: ICredentialsService;

  constructor(requestService, credentialsService) {
    this.requestService = requestService;
    this.credentialsService = credentialsService;
  }

  async execute() {
    const applicantId = this.credentialsService.getApplicantId();
    return this.requestService.getRequests(applicantId);
  }
}
